import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  LoadingOutlined
} from '@ant-design/icons';
import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      icons={{
        success: <CheckCircleOutlined className="size-4" />,
        info: <InfoCircleOutlined className="size-4" />,
        warning: <ExclamationCircleOutlined className="size-4" />,
        error: <CloseCircleOutlined className="size-4" />,
        loading: <LoadingOutlined className="size-4 animate-spin" />
      }}
      style={
        {
          '--border-radius': 'var(--radius-md)',
          '--normal-bg': 'var(--color-primary)',
          '--normal-text': 'var(--color-typography)',
          '--normal-border': 'var(--color-primary)',
          '--success-bg': 'var(--color-success)',
          '--success-text': 'var(--color-typography)',
          '--success-border': 'var(--color-success)',
          '--error-bg': 'var(--color-error-500)',
          '--error-text': 'var(--color-typography)',
          '--error-border': 'var(--color-error-500)',
          '--warning-bg': 'var(--color-warning-500)',
          '--warning-text': 'var(--color-typography)',
          '--warning-border': 'var(--color-warning-500)',
          '--info-bg': 'var(--color-primary)',
          '--info-text': 'var(--color-typography)',
          '--info-border': 'var(--color-primary)'
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
